module.exports = __webpack_public_path__ + "media/images/icons/envelope-closed-d4135eb44a11b93843ab94a69f5e4565.svg";